<script>
 import BookCard from './BookCard.svelte';
 export let books;
</script>

<div class="flex flex-wrap font-bold italic">
    {#each books as book (book._id)}
        <BookCard {book} /> {/each}
</div>
